import React, { useState } from "react";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import NavItems from "./navItems";
import { Buttton } from "../buttons";
import { PiUser } from "react-icons/pi";

const Navvbar = ({
    imgLink,
    brandName,
    navItems,
    className,
    userType,
    onPathClick,
    loginRedirection,
    ...props
}) => {
    const { t } = useTranslation();
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const handleClose = () => setShowOffcanvas(false);
    const handleShow = () => setShowOffcanvas(true);

    return (
        <Navbar expand="lg" className={`${className}`}>
            <Container fluid>
                <Navbar.Brand as={Link} to={imgLink}>
                    {brandName}
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleShow} />
                <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-block">
                    <Nav className="me-auto">
                        {navItems.map((item, index) => (
                            <NavItems
                                key={index}
                                title={t(item.title)}
                                items={item.items}
                                link={item.link}
                                userType={userType}
                            />
                        ))}
                    </Nav>
                </Navbar.Collapse>
                <div className="d-lg-block d-none">
                    <div className="login-select">
                        <Buttton children={props.icon} className="transparent" onClick={onPathClick} />

                        {props.languageSelect}
                    </div>
                </div>
            </Container>

            {/* Offcanvas component for small screens */}
            <Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                placement="start"
                className="off-canvas"
            >
                <Offcanvas.Header className="justify-content-between">
                    <Offcanvas.Title>{brandName}</Offcanvas.Title>
                    <div className="login-select">
                        {props.languageSelect}
                        <PiUser className="piuser" onClick={onPathClick}  />
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="me-auto">
                        {navItems.map((item, index) => (
                            <NavItems
                                key={index}
                                title={t(item.title)}
                                items={item.items}
                                link={item.link}
                                userType={userType}
                            />
                        ))}
                    </Nav>
                    {/* <div className="login-select mt-3">
                        {props.icon}
                        {props.languageSelect}
                    </div> */}
                </Offcanvas.Body>
            </Offcanvas>
        </Navbar>
    );
};

export default Navvbar;
